import dayjs from 'dayjs';

import { IChartStages, IGanttChartStatuses } from '../types';

export const getSortedFilteredGanttChartDataWithDuration = ({
  chartData,
  filter,
  startDate,
}: {
  chartData: IChartStages[];
  filter: IGanttChartStatuses;
  startDate: dayjs.Dayjs;
}): IChartStages[] =>
  chartData
    .filter(({ status }) => status.toLowerCase() === filter.toLowerCase())
    .sort((a, b) => {
      if (a.from.isBefore(b.from)) return -1;
      if (a.from.isAfter(b.from)) return 1;
      return 0;
    })
    .map((item) => ({
      ...item,
      duration: item.to.isValid() && item.from.isValid() ? item.to.diff(item.from, 'month') + 1 : 0, // adding one in case of same months to display it
      differenceWithStartDate: item.from.diff(startDate, 'month'),
    }));
